export enum EnergyMix {
  ElectricityAndGas = 'electricity_and_gas',
  Electricity = 'electricity',
  Gas = 'gas',
}
